#import "../fragments/product-context-fragment.graphql"

query GetSalesObjectionContext {
    products {
        edges {
            node {
                ...ProductContext
            }
        }
    }
}
